import { Dropdown, Space } from 'antd';
import './DropdownComponent.scss';
import { Icon } from '../../icon/icon';

const DropdownComponent = ({ containerProps, ...props }) => {
  return (
    <Dropdown {...props}>
      <Space className={'flex items-center'} {...containerProps}>
        {props.children}
        <span className="icon--expand flex w-18 h-18">
          <Icon.ICExpandMore />
        </span>
      </Space>
    </Dropdown>
  );
};

export default DropdownComponent;
